<template>
  <div id="mycource">
    <!-- 左边列表 -->
    <div class="mycource_list">
      <div class="mycource_list_title">
        包含<span
          ><a href="https://www.eduzhixin.com/#recommend" target="_blank"
            >质心官网</a
          ></span
        >购买的课程
      </div>
      <div class="mycource_list_nav">
        <div class="mycource_list_navleft">
          <div
            v-for="(item, index) in cource"
            :key="index"
            @click="change(index)"
            :style="
              stylestate === index
                ? ''
                : 'border-bottom: 2px solid white;color:rgba(51, 51, 51, 0.6)'
            "
          >
            {{ item.name }}
          </div>
        </div>
        <div class="mycource_list_navright">
          <el-dropdown trigger="click" class="mycource_list_subject">
            <span class="el-dropdown-link">
              {{ subjectText }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="changeSubject(item.value, item.title)"
                v-for="(item, index) in subjectList"
                :key="index"
                :style="subject === item.value ? 'color:#00C7BF;' : ''"
                >{{ item.title }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" class="mycource_list_state">
            <span class="el-dropdown-link">
              {{ stateText }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="changeState(0, '全部')"
                :style="state === 0 ? 'color:#00C7BF;' : ''"
                >全部</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="changeState(1, '进行中')"
                :style="state === 1 ? 'color:#00C7BF;' : ''"
                >进行中</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="changeState(2, '已完结')"
                :style="state === 2 ? 'color:#00C7BF;' : ''"
                >已完结</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="changeState(3, '未开始')"
                :style="state === 3 ? 'color:#00C7BF;' : ''"
                >未开始</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="mycource_list_card">
        <div v-if="classList.length !== 0" class="mycource_list_card">
          <div
            class="cardlist"
            @click="toinfo(item, classType)"
            v-for="(item, index) in classList"
            :key="index"
          >
            <ClassProcessCard
              :teacherlist="item.teacherInfo"
              :subclass="item.subclass"
              :subject="item.subject"
              :classState="item.classState"
              :classProcess="item.classProcess"
              :classLabel="stylestate"
            ></ClassProcessCard>
          </div>
        </div>
        <div
          class="class-list-empty"
          v-if="classList.length === 0 && classNoClass === 0"
        >
          <div class="not-found-container">
            <div class="img">
              <img src="@/assets/img/notFound@2x.png" alt />
            </div>
            <div class="tips">
              您暂无课程，可前往“<a
                href="https://www.eduzhixin.com/#recommend"
                style="color: #809bc5"
                >选择合适的课程</a
              >”
            </div>
          </div>
        </div>
        <div
          class="class-list-empty"
          v-if="classList.length === 0 && classNoClass === 1"
        >
          <div class="not-found-container">
            <div class="img">
              <img src="@/assets/img/notFound@2x.png" alt />
            </div>
            <div class="tips">
              您暂无课程，可前往质心灵动量“<span
                @click="toClass('offline')"
                style="color: #809bc5; cursor: pointer"
                >选择合适的课程”</span
              >
            </div>
          </div>
        </div>
        <div
          class="class-list-empty"
          v-if="classList.length === 0 && classNoClass === 2"
        >
          <div class="not-found-container">
            <div class="img">
              <img src="@/assets/img/notFound@2x.png" alt />
            </div>
            <div class="tips" @click="toClass('free')">
              您暂无讲座，可前往“<span
                @click="toClass('free')"
                style="color: #809bc5; cursor: pointer"
                >选择合适的讲座”</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边日历 -->
    <!-- arr=['2018/4/1','2018/4/3'] 标记4月1日和4月3日 简单标记 -->
    <div class="mycource_calendar">
      <Calender
        :calenderSend="calenderlist"
        v-if="calenderlist"
        @fresh="getMyAllCourse"
      ></Calender>
    </div>
  </div>
</template>
<script>
import ClassProcessCard from '@/components/ClassProcessCard'
import Calender from '@/components/Calendar'
import api from '@/api'
import fliter from '@/utils/filters'
export default {
  data () {
    return {
      cource: [{ name: '直播课' }, { name: '面授课' }, { name: '讲座' }],
      classList: [],
      stylestate: 0,
      classType: 'live',
      subject: '',
      subjectText: '学科',
      stateText: '课程状态',
      state: 0,
      calenderlist: [],
      classNoClass: 0,
      buyOfflineSubclass: [],
      subjectList: []
    }
  },
  components: {
    ClassProcessCard,
    Calender
  },
  methods: {
    handleGradeSubject () {
      const nowTime = parseInt(new Date().getTime() / 1000)
      api.getCourseLabel(nowTime).then((res) => {
        const subjectArr = []
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].subject.length; j++) {
            const obj = {
              title: res.data[i].subject[j].title,
              value: res.data[i].subject[j].value
            }
            const isHaveSubject = subjectArr.some((item) => {
              return item.title === obj.title
            })
            if (!isHaveSubject) {
              subjectArr.push(obj)
            }
          }
        }
        this.subjectList = subjectArr
      })
    },
    toClass (e) {
      if (e === 'offline') {
        // const routeUrl = this.$router.resolve({
        //   name: 'CourseList',
        //   params: { location: 'offline' }
        // })
        // window.open(routeUrl.href, '_blank')
        const routeUrl = this.$router.resolve({
          path: '/',
          query: { location: 'offline' }
        })
        window.open(routeUrl.href, '_blank')
      } else if (e === 'free') {
        this.$router.push({ name: 'Lecture' })
      }
    },
    changeSubject (e, q) {
      this.subjectText = q
      this.subject = e
      if (this.classType === 'live' && this.stylestate === 0) {
        this.getLiveClass()
      } else if (this.classType === 'offline') {
        this.getClassList()
      } else if (this.classType === 'live' && this.stylestate === 2) {
        this.getFreeClass()
      }
    },
    changeState (e, q) {
      this.stateText = q
      this.state = e
      if (this.classType === 'live' && this.stylestate === 0) {
        this.getLiveClass()
      } else if (this.classType === 'offline') {
        this.getClassList()
      } else if (this.classType === 'live' && this.stylestate === 2) {
        this.getFreeClass()
      }
    },
    change (e) {
      this.stylestate = e
      this.state = 0
      this.subject = ''
      this.subjectText = '学科'
      this.stateText = '课程状态'
      if (e === 0) {
        this.classType = 'live'
        this.classNoClass = e
        this.getLiveClass()
      } else if (e === 1) {
        this.classType = 'offline'
        this.classNoClass = e
        this.getClassList()
      } else if (e === 2) {
        this.classType = 'live'
        this.classNoClass = e
        this.getFreeClass()
      }
    },
    toinfo (item, classType) {
      // 未开始, 进行中, 已结束
      const classState = item.classState === '已完结' ? '已结束' : item.classState
      this.zhuGeEventTrack(this.zhugeEvents.MyCourseCardClick, [
        classType === 'live' ? '直播课' : '面授课',
        item.classId + '',
        item.subject ? item.subject + '' : '',
        classState,
        '我的课程'
      ])
      this.$router.push({
        name: 'MyCourseInfo',
        params: { classId: item.classId, classType: this.classType }
      })
    },
    getMyAllCourse () {
      api
        .getMyAllCourse()
        .then((r) => {
          if (r.data.code === 1) {
            const item = r.data.items
            for (let i = 0; i < item.length; i++) {
              this.buyOfflineSubclass[i] = item[i].subclass_id
            }
            this.calenderlist = item.map((item) => {
              const nowTime = parseInt(new Date().getTime() / 1000)
              const date = fliter.formatDate(item.begin_at).replace(/\./g, '/')
              const belong = item.course_belong
              const subinfo = item.subject
              const classSubject = item.class_subject
              const className = 'mark1'
              const time =
                fliter.formatTimestamp(item.begin_at).slice(11, 16) +
                '-' +
                fliter.formatTimestamp(item.end_at).slice(11, 16)
              const subClass = item.sub_index + '/' + item.subclass_count
              const classType = item.goods_type
              let btnState = 1
              let btnText = '' // eslint-disable-line no-unused-vars
              let href = ''
              // 按钮点击状态
              if (item.deadline_at !== null) {
                if (nowTime > item.deadline_at) {
                  btnState = 1
                } else if (
                  nowTime < item.deadline_at &&
                  nowTime < item.begin_at
                ) {
                  btnState = 1
                } else if (
                  nowTime < item.deadline_at &&
                  nowTime > item.begin_at
                ) {
                  btnState = 0
                }
              } else {
                if (classType === 2) {
                  if (nowTime < item.begin_at) {
                    btnState = 1
                  } else if (nowTime > item.begin_at) {
                    btnState = 0
                  }
                } else if (classType === 5) {
                  if (
                    this.buyOfflineSubclass.indexOf(Number(item.subclass_id)) >
                      -1 &&
                    nowTime > item.end_at
                  ) {
                    btnState = 0
                  } else {
                    btnState = 1
                  }
                }
              }
              // 按钮文字
              if (item.deadline_at !== null) {
                if (item.end_at < nowTime && nowTime < item.deadline_at) {
                  btnText = '看回放'
                } else if (
                  item.end_at > nowTime &&
                  nowTime < item.deadline_at
                ) {
                  btnText = '进入直播'
                } else if (
                  item.end_at < nowTime &&
                  nowTime > item.deadline_at
                ) {
                  btnText = '已过期'
                }
              } else {
                if (classType === 2) {
                  if (item.end_at < nowTime) {
                    btnText = '看回放'
                  } else if (item.end_at > nowTime) {
                    btnText = '进入直播'
                  }
                } else if (classType === 5) {
                  if (
                    this.buyOfflineSubclass.indexOf(Number(item.subclass_id)) >
                      -1 &&
                    nowTime > item.end_at
                  ) {
                    btnText = '看回放'
                  } else {
                    btnText = '线下面授'
                  }
                }
              }
              if (btnText === '看回放' && classType === 2) {
                href =
                  '/live/' +
                  item.class_id +
                  '/' +
                  item.subclass_id +
                  '/' +
                  'replay'
              } else if (btnText === '进入直播') {
                href =
                  '/live/' +
                  item.class_id +
                  '/' +
                  item.subclass_id +
                  '/' +
                  'live'
              } else if (btnText === '看回放' && classType === 5) {
                href =
                  '/offline-live/' + item.class_id + '/' + item.subclass_id
              } else if (btnText === '线下面授') {
                href = 'javascript:void(0)'
              }
              return {
                classType,
                subinfo,
                className,
                classSubject,
                date,
                time,
                btnState,
                btnText,
                subClass,
                href,
                belong
              }
            })
          } else {
          }
        })
        .catch((e) => {
          console.log('e: ', e)
        })
    },
    getClassList () {
      const params = {
        subject_type: this.subject,
        status: this.state
      }
      api
        .getMyCourse(params)
        .then((r) => {
          if (r.data.code === 1) {
            const item = r.data.data.list
            if (item) {
              this.classList = item.map((item) => {
                const nowTime = parseInt(new Date().getTime() / 1000)
                const teacherInfo = item.teachers_info
                const classId = item.class_id
                const subclass = item.subclass.length
                const subject = item.subject
                let classState = ''
                const classProcess = 0
                if (item.subclass[0].begin_at > nowTime) {
                  classState = '未开始'
                } else if (
                  item.subclass[0].begin_at < nowTime &&
                  nowTime < item.subclass[subclass - 1].end_at
                ) {
                  classState = '进行中'
                } else if (
                  item.subclass[0].begin_at < nowTime &&
                  nowTime > item.subclass[subclass - 1].end_at
                ) {
                  classState = '已完结'
                }
                // for (let i = 0; i < item.subclass.length; i++) {
                //   if (item.subclass[i].begin_at < nowTime) {
                //     classProcess++
                //   }
                // }
                return {
                  teacherInfo,
                  classId,
                  subclass,
                  subject,
                  classState,
                  classProcess
                }
              })
            } else {
              this.classList = []
            }
          } else {
          }
        })
        .catch((e) => {
          console.log('e: ', e)
        })
    },
    getLiveClass () {
      const params = {
        subject_type: this.subject,
        status: this.state
      }
      api
        .getMyCourseLive(params)
        .then((r) => {
          if (r.data.code === 1) {
            const item = r.data.items
            this.classList = item.map((item) => {
              const nowTime = parseInt(new Date().getTime() / 1000)
              const teacherInfo = item.teachers_info
              const classId = item.class_id
              const subclass = item.subclass.length
              const subject = String(item.subject)
              let classState = ''
              const beginat = item.begin_at
              let status // eslint-disable-line no-unused-vars
              let classProcess = 0
              if (item.subclass[0].begin_at > nowTime) {
                classState = '未开始'
                status = 0
              } else if (
                item.subclass[0].begin_at < nowTime &&
                nowTime < item.subclass[subclass - 1].end_at
              ) {
                classState = '进行中'
                status = 1
              } else if (
                item.subclass[0].begin_at < nowTime &&
                nowTime > item.subclass[subclass - 1].end_at
              ) {
                classState = '已完结'
                status = 2
              }
              for (let i = 0; i < item.subclass.length; i++) {
                if (item.subclass[i].begin_at < nowTime) {
                  classProcess++
                }
              }
              return {
                teacherInfo,
                classId,
                subclass,
                subject,
                classState,
                beginat,
                status,
                classProcess
              }
            })
            this.classList = this.classStatusProcess(this.classList, false)
          } else {
          }
        })
        .catch((e) => {
          console.log('e: ', e)
        })
    },
    getFreeClass () {
      const params = {
        subject_type: this.subject,
        status: this.state
      }
      api
        .getMyCourseFree(params)
        .then((r) => {
          if (r.data.code === 1) {
            const item = r.data.items
            this.classList = item.map((item) => {
              const nowTime = parseInt(new Date().getTime() / 1000)
              const teacherInfo = item.teachers_info
              const classId = item.class_id
              const subclass = item.subclass.length
              const subject = String(item.subject)
              let classState = ''
              const beginat = item.begin_at
              let status // eslint-disable-line no-unused-vars
              let classProcess = 0
              if (item.subclass[0].begin_at > nowTime) {
                classState = '未开始'
                status = 0
              } else if (
                item.subclass[0].begin_at < nowTime &&
                nowTime < item.subclass[subclass - 1].end_at
              ) {
                classState = '进行中'
                status = 1
              } else if (
                item.subclass[0].begin_at < nowTime &&
                nowTime > item.subclass[subclass - 1].end_at
              ) {
                classState = '已完结'
                status = 2
              }
              for (let i = 0; i < item.subclass.length; i++) {
                if (item.subclass[i].begin_at < nowTime) {
                  classProcess++
                }
              }
              return {
                teacherInfo,
                classId,
                subclass,
                subject,
                classState,
                classProcess,
                beginat,
                status
              }
            })
            this.classList = this.classStatusProcess(this.classList, true)
          } else {
          }
        })
        .catch((e) => {
          console.log('e: ', e)
        })
    },
    // 排序
    classStatusProcess: function (classesData, isFree) {
      var _this = this
      var now = []
      var end = []
      var future = []
      if (classesData.length === 0) {
        return classesData
      }
      var classes = JSON.parse(JSON.stringify(classesData))
      classes.forEach(function (clas) {
        if (clas.status === 0) {
          future.push(clas)
        } else if (clas.status === 1) {
          now.push(clas)
        } else {
          end.push(clas)
        }
      })
      now = now.sort(_this.sortClass('beginat', true))
      future = future.sort(_this.sortClass('beginat', true))
      if (isFree) {
        end = end.sort(_this.sortClass('beginat', true))
        // return end.concat(future).concat(now)
        return now.concat(future).concat(end)
      } else {
        end = end.sort(_this.sortClass('beginat', false))
        // return future.concat(end).concat(now)
        return now.concat(future).concat(end)
      }
    },
    sortClass: function (prop, isReverse) {
      return function (a, b) {
        var value1 = a[prop]
        var value2 = b[prop]
        if (!isReverse) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    }
  },
  created () {
    this.handleGradeSubject()
    this.stylestate = Number(this.$route.params.state) || 0
    this.change(this.stylestate)
    this.getMyAllCourse()
    // this.getClassList()
  }
}
</script>
<style lang="scss">
#mycource {
  width: 1140px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  margin-top: 16px;
  .mark1:after {
    position: absolute;
    bottom: 0;
    height: 5px;
    width: 5px;
    content: '';
    background: white;
    border-radius: 50%;
  }
  .mycource_list {
    width: 796px;
    .mycource_list_title {
      height: 38px;
      background: white;
      text-align: right;
      width: 100%;
      color: rgba(51, 51, 51, 0.4);
      line-height: 38px;
      border-bottom: 1px solid rgba(51, 51, 51, 0.06);
      font-size: 13px;
      box-sizing: border-box;
      padding-right: 24px;
      span {
        text-decoration: underline;
        color: rgba(63, 134, 232, 1);
        a {
          color: rgba(63, 134, 232, 1);
        }
      }
    }
    .mycource_list_nav {
      width: 100%;
      height: 52px;
      background: white;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      align-items: center;
      padding: 0px 26px;
      .mycource_list_navleft {
        display: flex;
        div {
          height: 28px;
          border-bottom: 2px solid rgba(0, 199, 191, 1);
          color: rgba(0, 199, 191, 1);
          margin-right: 48px;
          cursor: pointer;
        }
      }
      .mycource_list_navright {
        display: flex;
        .mycource_list_subject {
          width: 84px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(44, 45, 46, 0.3);
          text-align: center;
          line-height: 28px;
          margin-right: 16px;
          color: rgba(51, 51, 51, 0.6);
        }
        .mycource_list_state {
          width: 84px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(44, 45, 46, 0.3);
          text-align: center;
          line-height: 28px;
          color: rgba(51, 51, 51, 0.6);
        }
      }
    }
    .mycource_list_card {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      .cardlist {
        width: 386px;
        height: 249px;
        margin-bottom: 15px;
        // background: skyblue;
      }
    }
  }
  .mycource_calendar {
    width: 323px;
  }
}
@media (max-width: 375px) {
  #mycource {
    .mycource_list {
      width: 413px;
      .mycource_list_title {
        width: 392px;
      }
      .mycource_list_nav {
        width: 392px;
        .mycource_list_navleft div {
          height: 28px;
          border-bottom: 2px solid #00c7bf;
          margin-right: 13px;
        }
      }
      .mycource_list_card {
        justify-content: center;
        width: 373px;
      }
    }
    .mycource_calendar {
      display: none;
    }
  }
}
@media (max-width: 768px) and (min-width: 375px) {
  #mycource {
    width: 754px;
    .mycource_list {
      width: 413px;
      .mycource_list_nav .mycource_list_navleft div {
        height: 28px;
        border-bottom: 2px solid #00c7bf;
        margin-right: 13px;
      }
      .mycource_list_card {
        justify-content: center;
      }
    }
    .mycource_calendar {
      width: 323px;
    }
  }
}
@media (max-width: 1023px) and (min-width: 769px) {
  #mycource {
    width: 755px;
    .mycource_list {
      width: 431px;
      .mycource_list_nav .mycource_list_navleft div {
        height: 28px;
        border-bottom: 2px solid #00c7bf;
        margin-right: 20px;
      }
    }
  }
}
@media (max-width: 1372px) and (min-width: 1024px) {
  #mycource {
    width: 999px;
    .mycource_list {
      width: 657px;
      .mycource_list_card {
        .cardlist {
          width: 310px;
        }
      }
    }
  }
}
</style>
